var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.memberData.length === 0)?_c('member-empty-link',{attrs:{"emptyLayout":_vm.emptyLayout}}):_c('member-list-link',{attrs:{"memberData":_vm.memberData,"listLayout":_vm.listLayout}})
}
var staticRenderFns = []

export { render, staticRenderFns }